<template>
	<kinesis-container 
		:event='"scroll"' 
		:duration="1"
		v-for="(icon, index) in icons"
		class="random-icons"
		:style="'top:' + randomPos().top + 'px;left:' + randomPos().left + 'px;'"
		:key="'icon' + index" >

		<kinesis-element 
			:strength="300" >

			<img 
				:src='require("@/assets/images/icons/" + icon)' 
				alt=""
			/>

		</kinesis-element>
	</kinesis-container>
</template>

<script>


	export default {
		name: 'Randomicons',
		props: ['aantal'],
		components: {
		},
		data() {
			return {
				icons: []
			};
		},
		mounted() {
			console.log(this.aantal, this.icons);

			this.generateIcons(this.aantal);
			
		},
		methods: {
			distanceToTop(id) {
				const el = document.querySelector(id);
				return el.getBoundingClientRect().top;
			},
			randomNr(min, max) {
				return Math.floor(Math.random() * max) + min;
			},
			generateIcons(aantal) {
				for (let i = 0; i < aantal; i++) {
					this.icons[i] = "icon_" + this.randomNr(1, 20) + ".png";
				}
			},
			randomPos() {
				// const dist = this.distanceToTop("#knd-kop");
				const dist = 2500;

				const pos = {
					left: this.randomNr(0, (window.innerWidth - 120)),
					top: this.randomNr(dist, (28000 - dist))
				}
				return pos;
			}
		}
	}
</script>